import { render, staticRenderFns } from "./NotificationLink.vue?vue&type=template&id=5e5f2753"
import script from "./NotificationLink.vue?vue&type=script&lang=js"
export * from "./NotificationLink.vue?vue&type=script&lang=js"
import style0 from "./NotificationLink.vue?vue&type=style&index=0&id=5e5f2753&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports